import { useSkin, type Skin } from './useSkin';

/* Names that change with the skin: the arcade keeps its guild vocabulary, Inevitrade speaks plain trader. */
const COPY = {
  arcade: {
    hub: ['THE', 'STUDY'],
    hubBack: 'Study',
    ledger: ['TRADE', 'LEDGER'],
    ledgerStats: 'LEDGER',
    trackerDoor: 'Trade Tracker',
    mentorDoor: 'Mentor Hall',
    snapshot: false,
    tiers: { steady: 'Shield', push: 'Sword', max: 'Hammer' },
  },
  inevitrade: {
    hub: ['HOME', 'BASE'],
    hubBack: 'Home Base',
    ledger: ['TRADE', 'LOG'],
    ledgerStats: 'STATS',
    trackerDoor: 'Trade Log',
    mentorDoor: 'Mentor Room',
    snapshot: true,
    tiers: { steady: 'Steady', push: 'Push', max: 'Max' },
  },
} satisfies Record<Skin, unknown>;

export function useSkinCopy() {
  return COPY[useSkin().skin];
}
